const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Merhaba',
    'Ref: Page content body': 'Varışta ve kalkışta lütfen QR kod otobüsünüzü taramayı unutmayın.',
  },
};
export default labels;
